import React, {PropTypes, Component} from 'react'
import classnames from 'classnames'

class ClassOneStatusTd extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    classInfo: PropTypes.object.isRequired
  }

  render(){
    let {classInfo} = this.props
    let {totalQuantity, usedLessonTimes} = classInfo

    return(
      <div className='class-status'>
        {usedLessonTimes +  '/' + totalQuantity + ' ' + __('','classdetail') }
      </div>
    )
  }
}


export default ClassOneStatusTd



// WEBPACK FOOTER //
// ./src/containers/pages/ClassOne/ClassOneTable/ClassOneStatusTd.js